import React, {Fragment, useEffect, useState} from "react";
import SideBar from "./SideBar";
import NavHader, {NavMenuToggle} from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";
import logo from "../../../images/logo.png";
import minLogo from "../../../images/mini-logo.png";
import MenuListItems from "./MenuList";
import {Dropdown} from "react-bootstrap";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {Link, useLocation} from "react-router-dom";
import IdBadgeIcon from "../../../images/icons/idbadge";
import BancIcon from "../../../images/icons/bancIcon";
import LockIcon from "../../../images/icons/lockIcon";
import Logout from "./Logout";
import {connect, useDispatch, useSelector} from "react-redux";
import {
  getUser,
  isAuthenticated,
  isLoading,
} from "../../../store/selectors/AuthSelectors";
import PerfectScrollbar from "react-perfect-scrollbar";

import {userRoleList} from "../../../utils/constants";
import profile from "../../../images/profileImage.png";
import useSocket from "../../../socket/useSocket";
import {socket} from "../../../socket/socket";
import {
  useMarkAsRead,
  useNotification,
  useNotificationPermission,
  useNotifications,
} from "../../../hooks/useNotification";
import NotificationItem from "./notificationItem";
import SideNav from "./sideNav";
import {getNotifs} from "../../../store/selectors/NotifSelectors";
import {markNotifAsRead} from "../../../store/actions/notifActions";
import {set} from "react-hook-form";

const JobieNav = ({
  title,
  user,
  onClick: ClickToAddEvent,
  onClick2,
  onClick3,
  notifs,
}) => {
  const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const {data, isError, isLoading} = useNotifications({page: 0, size: 20});
  const [groupedNotifications, setGroupedNotifications] = useState([]);
  const {UnRead} = useSelector((state) => state.notifs);
  const {onMarkAsRead} = useMarkAsRead();

  useEffect(() => {
    if (data && data?.length) {
      const unRead = data?.find((notif) => {
        return notif?.receivers?.find(
          (receiver) =>
            receiver?.id === user?.id &&
            receiver?.NotificationReceiver?.isRead === false,
        );
      });

      const formatChatMessage = (message, count) => {
        const formatted = message.replace(
          /\b(un|une)\s+message\b/i,
          `${count} ${count > 1 ? "messages" : "message"}`,
        );
        return formatted === message
          ? `${message} (${count} ${count > 1 ? "messages" : "message"})`
          : formatted;
      };

      const groupedNotifs = data.reduce((acc, notification) => {
        const key =
          notification.notifiableType === "chatMessage" &&
          notification.chatroomId != null
            ? `chatMessage-${notification.chatroomId}`
            : `${notification.notifiableType}-${
                notification.notifiableId ?? notification.id
              }`;

        if (!acc[key]) {
          acc[key] = {
            ...notification,
            messages: [notification.message],
            originalMessage: notification.message,
          };
        } else {
          acc[key].messages.push(notification.message);
          if (notification.notifiableType === "chatMessage") {
            const baseMessage =
              acc[key].originalMessage || notification.message;
            acc[key].message = formatChatMessage(
              baseMessage,
              acc[key].messages.length,
            );
          }
          if (
            notification.notifiableType === "offer" &&
            user?.selectedRole === userRoleList.TECHNICIAN
          ) {
            acc[key].message =
              `  Des annonces qui pourraient vous intéresser viennent d'être publiées.`;
          }
        }

        return acc;
      }, {});

      // Convert the grouped object into an array
      const result = Object.values(groupedNotifs);
      setGroupedNotifications(result);

      dispatch(markNotifAsRead(!!unRead));
    }
  }, [data]);

  return (
    <Fragment>
      <div
        className={`w-full  flex flex-col justify-start items-start fixed top-0 left-0 z-[999]  `}
      >
        <header className="w-full bg-white border-b   ">
          <div
            className={`  px-4 ${
              location.pathname.includes("messages")
                ? "mx-0 w-full lg:px-2"
                : "mx-auto lg:max-w-[73%] lg:min-w-[1010px] lg:!px-0"
            } flex justify-between items-center  lg:grid lg:grid-cols-4 lg:gap-4`}
          >
            {/* logo col  */}
            <Link
              className="flex items-center justify-start py-[10px] max-lg:hidden"
              to=""
              aria-label="Accueil Help Clic"
            >
              <img className="max-lg:hidden max-h-[48px]" src={logo} alt="Help Clic" />
            </Link>
            <Link
              to=""
              className="flex items-center justify-start py-[10px] lg:hidden "
              aria-label="Accueil Help Clic"
            >
              <img className="lg:hidden max-h-[48px] " src={minLogo} alt="Help Clic" />
            </Link>
            {/* nav menu  */}
            <MenuListItems className={"col-span-2 "} />
            {/* popup menu  */}
            <div className="flex justify-end items-center gap-2 py-[10px]">
              {user?.selectedRole === userRoleList.CLIENT && (
                <Link
                  to="/deposer-une-annonce"
                  className="lg:hidden"
                  aria-label="Créer une annonce"
                >
                  <div className="!bg-[#ffeadd] !w-10 !h-10 !rounded-full relative flex justify-center items-center text-lg text-[#ff6600]">
                    <i className="fi fi-rr-add flex justify-center items-center"></i>
                  </div>
                </Link>
              )}
              <Dropdown
                as="div"
                className="nav-item dropdown notification_dropdown cursor-pointer "
                onToggle={(isOpen) => {
                  if (isOpen && UnRead) {
                    onMarkAsRead();
                  }
                }}
              >
                <Dropdown.Toggle
                  variant=""
                  className=" i-false !p-0 "
                  aria-label="Notifications"
                >
                  <div className="!bg-[#E9F0F8] !w-10 !h-10 !rounded-full relative flex justify-center items-center text-lg text-[#1A64B9]">
                    <i className="fi fi-rr-bell flex justify-center items-center"></i>
                    {(!!notifs.length || UnRead) && (
                      // <div className="w-2 h-2 rounded-full bg-[#FF6600] absolute top-0 right-0" />
                      <div className="pulse-css" />
                    )}
                  </div>
                </Dropdown.Toggle>
                {/* <Dropdown.Menu align="right" className="mt-2 w-[350px] ">
                  
                  {!!notificationList.length ? (
                    notificationList.map((el) => (
                      <NotificationItem notification={el} key={el?.messageId} />
                    ))
                  ) : (
                    <div className="text-left w-full text-sm p-3">
                      vous n'avez pas de nouvelles notifications
                    </div>
                  )}
                  <Link to="/notifications" className="dropdown-item ai-icon">
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-bell flex justify-center items-center"></i>
                      </span>
                      <span className=" text-[#3D4465]">
                        Voir toutes les notifications
                      </span>
                    </div>
                  </Link>
                </Dropdown.Menu> */}
                <Dropdown.Menu align="right" className="mt-2">
                  <PerfectScrollbar
                    className={`widget-media dz-scroll p-3 ${
                      data?.length >= 2 ? "h-[380px]" : "h-[100px]"
                    } ps`}
                  >
                    <ul className="timeline">
                      {!!data?.length ? (
                        groupedNotifications?.map((el) => (
                          <NotificationItem notification={el} key={el?.id} />
                        ))
                      ) : (
                        <div className="text-left w-full text-sm p-3">
                          Pas de notifications.
                        </div>
                      )}
                    </ul>
                    <div className="ps__rail-x" style={{left: 0, bottom: 0}}>
                      <div
                        className="ps__thumb-x"
                        tabIndex={0}
                        style={{left: 0, width: 0}}
                      />
                    </div>
                    <div className="ps__rail-y" style={{top: 0, right: 0}}>
                      <div
                        className="ps__thumb-y"
                        tabIndex={0}
                        style={{top: 0, height: 0}}
                      />
                    </div>
                  </PerfectScrollbar>
                  <Link className="all-notification" to="/notifications">
                    Voir toutes les notifications{" "}
                    <i className="ti-arrow-right" />
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown
                as="div"
                className="nav-item dropdown header-profile cursor-pointer hidden lg:block"
              >
                <Dropdown.Toggle
                  variant=""
                  as="button"
                  aria-label="Menu du profil"
                  className="nav-link i-false !p-0 relative"
                >
                  <div
                    className="absolute bottom-0 right-0 rounded-full w-4 h-4 text-xs border border-white border-solid flex justify-center
                items-center bg-[#dadada] text-[#3D4465]"
                  >
                    <i className="fi fi-rr-angle-small-down flex items-center"></i>
                  </div>
                  {/* <img src={profile} width={20} alt="profile" /> */}
                  <ImageComponent
                    src={buildImageUrl(user?.imageUri)}
                    className="w-10 aspect-square rounded-full object-cover"
                    alt="profile"
                    fallback={
                      <img
                        src={profile}
                        className="w-10 aspect-square rounded-full object-cover"
                        alt="profile"
                      />
                    }
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu align="right" className="mt-2 w-[350px] ">
                  <Link to="/mon-profil" className="dropdown-item ai-icon ">
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-user flex items-center"></i>
                      </span>
                      <span className=" text-[#3D4465] ">Mon profil </span>
                    </div>
                  </Link>
                  <Link to="/mon-compte" className="dropdown-item ai-icon ">
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-user-gear flex items-center"></i>
                      </span>
                      <span className=" text-[#3D4465] ">Mon compte </span>
                    </div>
                  </Link>
                  <Link to="/reclamations" className="dropdown-item ai-icon ">
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-megaphone-sound-waves flex items-center"></i>
                      </span>
                      <span className=" text-[#3D4465] ">Réclamations </span>
                    </div>
                  </Link>
                  {user.signedBy === "PASSWORD" && (
                    <Link
                      to="/changer-mot-de-passe"
                      className="dropdown-item ai-icon"
                    >
                      <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                        <span className="text-xl">
                          <i className="fi fi-rr-lock flex items-center"></i>
                        </span>
                        <span className=" text-[#3D4465]">
                          Changer mot de passe
                        </span>
                      </div>
                    </Link>
                  )}
                  {user.selectedRole === userRoleList.TECHNICIAN && (
                    <Link to="/paiement" className="dropdown-item ai-icon">
                      <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                        <span className="text-xl">
                          <i className="fi fi-rr-credit-card flex items-center"></i>
                        </span>
                        <span className=" text-[#3D4465]">Paiement</span>
                      </div>
                    </Link>
                  )}
                  <Link to="/factures" className="dropdown-item ai-icon">
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-file-invoice flex items-center"></i>
                      </span>
                      <span className=" text-[#3D4465]">Mes factures</span>
                    </div>
                  </Link>
                  <Link
                    to="/parametres-du-compte"
                    className="dropdown-item ai-icon"
                  >
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-settings flex items-center"></i>
                      </span>
                      <span className=" text-[#3D4465]">
                        Paramètres du compte
                      </span>
                    </div>
                  </Link>
                  <Link
                    to="/conditions-generales"
                    className="dropdown-item ai-icon"
                  >
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-memo-circle-check flex items-center"></i>
                      </span>
                      <span className=" text-[#3D4465]">
                        Conditions générales
                      </span>
                    </div>
                  </Link>
                  <Link
                    to="/politique-de-confidentialite"
                    className="dropdown-item ai-icon"
                  >
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-lock flex items-center"></i>
                      </span>
                      <span className="text-[#3D4465]">
                        Politique de confidentialité
                      </span>
                    </div>
                  </Link>
                  <Link to="/centre-aide" className="dropdown-item ai-icon">
                    <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                      <span className="text-xl">
                        <i className="fi fi-rr-life-ring flex items-center"></i>
                      </span>
                      <span className=" text-[#3D4465]">Aide</span>
                    </div>
                  </Link>
                  {/* {user.selectedRole === userRoleList.TECHNICIAN && (
                  <Link to="/banques" className="dropdown-item ai-icon">
                    <div className="w-full flex gap-2">
                      <BancIcon />
                      <span className="ml-2 text-[#3D4465]">
                        Coordonnées bancaires
                      </span>
                    </div>
                  </Link>
                )} */}

                  <Logout />
                </Dropdown.Menu>
              </Dropdown>
              <div
                className="lg:hidden flex justify-center px-2 items-center text-2xl text-[#191e68] cursor-pointer"
                onClick={() => setToggle((prev) => !prev)}
              >
                <i className="fi fi-rr-menu-burger flex items-center"></i>
              </div>
            </div>
          </div>
        </header>
        <SideNav toggleMenu={toggle} />
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
    isLoading: isLoading(state),
    user: getUser(state),
    notifs: getNotifs(state),
  };
};

export default connect(mapStateToProps)(JobieNav);
